import { render, staticRenderFns } from "./GameTypeLabel.vue?vue&type=template&id=4c1ed9a8&"
import script from "./GameTypeLabel.vue?vue&type=script&lang=js&"
export * from "./GameTypeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports